/* Primal Print & Design Studio : pp.js (= future assets/pp.js). Vanilla, no dependencies. */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal: everything is visible at rest; only below-the-fold items get hidden and played in */
  function initReveal() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.pp-r'));
    if (reduce || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight;
    items.forEach(function (n) { if (n.getBoundingClientRect().top < vh * 0.92) n.classList.add('is-in'); });
    doc.classList.add('pp-js');
    var show = function (n) { n.classList.add('is-in'); io.unobserve(n); };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting || e.boundingClientRect.top < 0) show(e.target); });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (n) { if (!n.classList.contains('is-in')) io.observe(n); });
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var lim = window.innerHeight * 0.95;
        items.forEach(function (n) { if (!n.classList.contains('is-in') && n.getBoundingClientRect().top < lim) show(n); });
      });
    }, { passive: true });
  }

  /* phone drawer */
  function initDrawer() {
    var drawer = document.getElementById('pp-drawer');
    var opener = document.querySelector('[data-drawer-open]');
    if (!drawer || !opener) return;
    var close = drawer.querySelector('[data-drawer-close]');
    function set(open) {
      drawer.hidden = !open;
      opener.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      (open ? close : opener).focus();
    }
    opener.addEventListener('click', function () { set(true); });
    close.addEventListener('click', function () { set(false); });
    drawer.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) set(false); });
  }

  /* footer columns: open lists on desktop, accordions on phones */
  function initFooter() {
    var mq = window.matchMedia('(max-width: 767px)');
    var cols = document.querySelectorAll('.pp-fcol');
    function apply() { cols.forEach(function (d) { d.open = !mq.matches; }); }
    apply();
    mq.addEventListener('change', apply);
    cols.forEach(function (d) {
      d.querySelector('summary').addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); });
    });
  }

  /* gang sheet size: one state shared by the ladder, the chips, the chart and the sticky bar */
  var money = function (n) { return '$' + Number(n).toFixed(2); };
  function selectSize(len, price) {
    var label = '22 × ' + len + ' in';
    document.querySelectorAll('[data-len]').forEach(function (b) {
      var on = b.getAttribute('data-len') === String(len);
      if (b.matches('input')) b.checked = on; else b.setAttribute('aria-pressed', String(on));
    });
    document.querySelectorAll('[data-readout-size],[data-bar-size]').forEach(function (n) { n.textContent = label; });
    document.querySelectorAll('[data-readout-price],[data-price]').forEach(function (n) { n.textContent = money(price); });
    document.querySelectorAll('[data-price-note]').forEach(function (n) { n.textContent = label + ' sheet'; });
    document.querySelectorAll('[data-bar-price]').forEach(function (n) { n.textContent = money(price) + ' per sheet'; });
  }
  function initSizes() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-len]');
      if (b) selectSize(b.getAttribute('data-len'), b.getAttribute('data-p'));
    });
    document.addEventListener('change', function (e) {
      var i = e.target.closest('input[data-len]');
      if (i) selectSize(i.getAttribute('data-len'), i.getAttribute('data-p'));
    });
    document.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = document.getElementById('pp-qty');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      });
    });
    var buy = document.querySelector('[data-buy]');
    if (buy) buy.addEventListener('submit', function (e) { e.preventDefault(); });
  }

  /* product gallery: native scroll-snap track, thumbs + counter follow it */
  function initGallery() {
    var g = document.querySelector('[data-gallery]');
    if (!g) return;
    var track = g.querySelector('[data-track]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    var count = g.querySelector('[data-count]');
    var total = track.children.length;
    function mark(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      count.textContent = (i + 1) + ' / ' + total;
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-thumb'), 10);
        track.scrollTo({ left: track.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
        mark(i);
      });
    });
    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
  }

  /* sticky buy bar on phones: shows once the main button has left the screen */
  function initBuyBar() {
    var bar = document.querySelector('[data-buybar]');
    var main = document.querySelector('[data-main-buy]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      bar.setAttribute('aria-hidden', String(!past));
    }).observe(main);
  }

  /* quote form: file list + designed success state (no real submission in the mock) */
  function initQuote() {
    var form = document.querySelector('[data-quote]');
    if (!form) return;
    var drop = form.querySelector('[data-drop]');
    var input = form.querySelector('#q-files');
    var list = form.querySelector('[data-files]');
    input.addEventListener('change', function () {
      list.innerHTML = '';
      Array.prototype.forEach.call(input.files, function (f) {
        var li = document.createElement('li');
        li.textContent = f.name + ' · ' + Math.max(1, Math.round(f.size / 1024)) + ' KB';
        list.appendChild(li);
      });
    });
    ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.remove('is-over'); }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var done = form.querySelector('[data-done]');
      done.hidden = false;
      done.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
  }

  initReveal(); initDrawer(); initFooter(); initSizes(); initGallery(); initBuyBar(); initQuote();
})();
